import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import Company from './routes/Company';

const Settings = ({match}) => (
	<div>
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/company`}/>
			<Route path={`${match.url}/company`} component={ Company } />
		</Switch>
	</div>
);

export default Settings;


// WEBPACK FOOTER //
// ./app/used/settings/index.js